import { IConfig } from '@alberta/konexi-shared';
import { Inject, Injectable, NgZone } from '@angular/core';
import { ConfigChannel } from 'src/app/business/config/contract/config-channel';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';

import { ISyncState } from 'src/app/common/contracts/sync/sync-state';
import { ConfigModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { EventService } from '../event.service';
import { TenantConfigService } from '../tenant-config/tenant-config.service';
import { SyncService } from './sync.service';

@Injectable()
export class ConfigSyncService extends SyncService<IConfig> {
  constructor(
    @Inject(AppController) appController: IAppController,
    @Inject(Dispatcher) dispatcher: IDispatcher<IConfig>,
    eventService: EventService<SyncProgressEvent>,
    ngZone: NgZone,
    @Inject(PlatformSyncToken) platformSync: IPlatformSync,
    private _tenantConfigService: TenantConfigService
  ) {
    super(ConfigModelName, appController, dispatcher, eventService, ngZone, platformSync);
  }

  public canSync(channel: string): boolean {
    return channel === ConfigChannel.CREATE || channel === ConfigChannel.EDIT || channel === ConfigChannel.DELETE;
  }

  protected async afterSync(syncState: ISyncState<IConfig>): Promise<void> {
    await super.afterSync(syncState);
    this._tenantConfigService.updateTenantConfig(syncState.updated?.[0]);
  }
}
